<ideal-lead-time-notification-chip [stockLocation]="stockLocation()" *renderInItemStock />
